import {Box, Chip, Link, Stack, Typography} from "@mui/material";
import AssignmentIcon from "@mui/icons-material/Assignment";
import EventIcon from "@mui/icons-material/Event";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import {Document} from "./document.model";
import {formatDate} from "~/app/components/date/date";
import {buildDocumentTitle, contentLabel} from "~/app/components/document/document.labels";

interface DocumentEntryProps {
  document: Document;
}

function DocumentEntry({document}: DocumentEntryProps) {
  return (
    <Box
      sx={{
        borderBottom: "1px solid #e0e0e0",
        py: 3
      }}
    >
      <Typography variant="overline">
        {buildDocumentTitle(document)}
      </Typography>

      <Stack
        direction="row"
        spacing={0.5}
        alignItems="center"
      >
        {document.contentTypes && document.contentTypes.length > 0 && (
          <Stack
            direction="row"
            spacing={1}
            flexWrap="wrap"
          >
            {document.contentTypes.map((ct) => (
              <Chip
                key={ct}
                label={contentLabel(ct)}
                size="small"
                variant="outlined"
                sx={{
                  borderColor: "divider",
                  color: "text.secondary",
                  backgroundColor: "grey.50",
                  fontWeight: 400
                }}
              />
            ))}
          </Stack>
        )}
      </Stack>

      <Stack
        direction="row"
        alignItems="center"
        sx={{mt: 1}}
      >
        <Typography variant="h6" sx={{fontWeight: 500}}>
          {document.institution}
        </Typography>
      </Stack>

      <Stack
        direction="row"
        spacing={1.5}
        alignItems="center"
        sx={{mt: 0.5}}
      >
        <EventIcon fontSize="small"/>
        <Typography variant="body2">
          {formatDate(document.date)}
        </Typography>
      </Stack>

      <Stack
        direction="row"
        spacing={1.5}
        alignItems="center"
        sx={{mt: 0.5}}
      >
        <AssignmentIcon fontSize="small"/>
        <Typography variant="body2">
          Aktenzeichen: {document.reference}
        </Typography>
      </Stack>

      <Link
        href={document.href}
        target="_blank"
        rel="noopener"
        sx={{
          mt: 0.5,
          display: "inline-flex",
          alignItems: "center",
          gap: 1.5
        }}
      >
        <PictureAsPdfIcon fontSize="small"/>
        Originaldokument (PDF)
      </Link>
    </Box>
  );
}

export default DocumentEntry;
